/**
 * @desc 系统提示信息, 包括错误信息提示, 方便后期做国际化
 */
import {
    UserLevel,
    UserStatus,
    ReportStatus,
    RiskFraudType,
    AccountStatus,
    AccountType,
    PicturePageCode,
    ReportType,
    ReportDateType,
    DangerType
} from './enum';

export default {
    500: '网络繁忙, 请稍后再试',
    REQUIRED_TOKEN_ERROR: '登录过期,请重新登录',
    SYSTEM_ERROR: '网络繁忙, 请稍后再试',
    BROWSER_ERROR: '网络繁忙, 请稍后再试',
    RESPONSE_ERROR: '请求数据异常',
    DATA_TRANSFORM_ERROR: '数据转换异常',
    UPLOAD_FILE_SIZE_ERROR: '上传文件不能大于2M',
    UPLOAD_FILE_TYPE_ERROR: '上传格式有误'
};

export const ReportStatusText = {
    [ReportStatus.FAIL]: '生成失败',
    [ReportStatus.SUCCESS]: '生成成功'
};

export const RiskFraudTypeText = {
    [RiskFraudType.FRAUD]: '财务舞弊',
    [RiskFraudType.RISK]: '财务风险'
};

export const AccountStatusText = {
    [AccountStatus.ENABLE]: '启用',
    [AccountStatus.DISABLE]: '禁用'
};

export const AccountTypeText = {
    [AccountType.ADMIN]: '管理员',
    [AccountType.NORMAL]: '普通用户'
};

export const PicturePageText = {
    [PicturePageCode.OVERVIEW]: '概述',
    [PicturePageCode.INFO]: '基本信息',
    [PicturePageCode.PUNISH]: '监管信息',
    [PicturePageCode.FRAUD]: '财务舞弊分析',
    [PicturePageCode.RISK]: '财务风险分析'
};

export const PicturePageLink = {
    [PicturePageCode.OVERVIEW]: '/cwhx/sy/gs',
    [PicturePageCode.INFO]: '/cwhx/sy/jbxx',
    [PicturePageCode.PUNISH]: '/cwhx/sy/lscf',
    [PicturePageCode.FRAUD]: '/cwhx/sy/cwzjfx',
    [PicturePageCode.RISK]: '/cwhx/sy/cwfxfx'
};

export const ReportDateTypeText = {
    [ReportDateType.YEAR]: '年报',
    [ReportDateType.THIRD_QUARTER]: '三季报',
    [ReportDateType.SECOND_QUARTER]: '半年度',
    [ReportDateType.FIRST_QUARTER]: '一季报'
};

export const ReportDateTypeMonth = {
    [ReportDateType.YEAR]: '12',
    [ReportDateType.THIRD_QUARTER]: '9',
    [ReportDateType.SECOND_QUARTER]: '6',
    [ReportDateType.FIRST_QUARTER]: '3'
};

export const ReportDateTypeDay = {
    [ReportDateType.YEAR]: '31',
    [ReportDateType.THIRD_QUARTER]: '30',
    [ReportDateType.SECOND_QUARTER]: '30',
    [ReportDateType.FIRST_QUARTER]: '31'
};

export const ReportTypeText = {
    [ReportType.FINAL_ADJUST]: '合并期末_调整',
    [ReportType.FINAL]: '合并期末',
    [ReportType.PARENT_FIRM_ADJUST]: '母公司期末_调整',
    [ReportType.PARENT_FIRM]: '母公司期末'
};

export const DangerTypeText = {
    [DangerType.RISK]: '财务风险隐患',
    [ReportType.MOTIVE]: '舞弊动机',
    [ReportType.APPEARANCE]: '舞弊表象'
};

export const LettersTypeText = {
    '1': '深交所监管措施',
    '2': '深交所问询函',
    '3': '深交所处罚记录',
    '4': '深交所承诺与履行',
    '5': '上交所监管措施',
    '6': '上交所问询函',
    '7': '上交所承诺与履行',
    '8': '海关失信',
    '9': '证监会行政监管措施',
    '10': '证监会行政处罚'
};

/**
 * @desc Demo
 * 根据用户等级, 在页面显示对应的中文, 正式开发时请删除 Demo 代码段.
 */
export const UserLevelText = {
    [UserLevel.NORMAL]: '普通会员',
    [UserLevel.VIP]: 'VIP会员'
};

export const UserStatusText = {
    [UserStatus.ENABLE]: '启用',
    [UserStatus.DISABLE]: '禁用'
};
/**
 * Demo end
 */



// WEBPACK FOOTER //
// ./src/constants/info.js